import {CardColor} from "./api/CardColor";
import {CardName} from "./api/CardName";
import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class CardAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "cardTurn",
        STATES: {
            IDLE_CARD: "idle_card",
            IDLE_COVERED: "idle_covered",
            UNCOVER: "uncover",
            UNCOVER_FAST: "uncover_fast",
            PULSE: "pulse",
        },
        SLOT_CONTAINERS: {
            CARD_FRONT: "plain",
        },
    };

    private static readonly CARD_FRONT_ANIMATION_NAME = "cardFront";

    private cardFront: CustomSpineAnimation;

    constructor() {
        super(CardAnimation.ANIMATION_CONFIG.NAME);
        this.createAndAddCardFrontAnimation();
        this.showCoveredCard();
    }

    public async uncoverCard(): Promise<void> {
        await this.playThanResolveOnAnimationCompleteAndRemoveAllListeners(
            CardAnimation.ANIMATION_CONFIG.STATES.UNCOVER);
    }

    public async uncoverCardFast(): Promise<void> {
        await this.playThanResolveOnAnimationCompleteAndRemoveAllListeners(
            CardAnimation.ANIMATION_CONFIG.STATES.UNCOVER_FAST);
    }

    public showUncoveredCard(): void {
        this.play(CardAnimation.ANIMATION_CONFIG.STATES.IDLE_CARD);
    }

    public showCoveredCard(): void {
        this.play(CardAnimation.ANIMATION_CONFIG.STATES.IDLE_COVERED);
    }

    public pulseCard(): void {
        this.play(CardAnimation.ANIMATION_CONFIG.STATES.PULSE, true);
    }

    public setCardFront(cardColor: CardColor, cardName: CardName): void {
        this.cardFront.play(cardColor + "_" + cardName);
    }

    private createAndAddCardFrontAnimation(): void {
        this.cardFront = new CustomSpineAnimation(CardAnimation.CARD_FRONT_ANIMATION_NAME);
        this.setCardFront(CardColor.SPADE, CardName.ACE);
        const slot = this.getSlotContainer(CardAnimation.ANIMATION_CONFIG.SLOT_CONTAINERS.CARD_FRONT, true);
        slot.addChild(this.cardFront);
        this.cardFront.scale.y = -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/CardAnimation.ts